{
  "setup.index": {
    "uri": "setup",
    "methods": ["GET", "HEAD"]
  },
  "setup.check-database": {
    "uri": "setup\/check-database",
    "methods": ["POST"]
  },
  "setup.complete": {
    "uri": "setup\/complete",
    "methods": ["POST"]
  },
  "auth.ecoid.redirect": {
    "uri": "auth\/ecoid\/redirect",
    "methods": ["GET", "HEAD"]
  },
  "auth.ecoid.redirect.user": {
    "uri": "auth\/ecoid\/redirect\/user\/{user?}",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"]
  },
  "auth.ecoid.redirect.company": {
    "uri": "auth\/ecoid\/redirect\/company\/{company}",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"]
  },
  "auth.ecoid.callback": {
    "uri": "auth\/ecoid\/callback",
    "methods": ["GET", "HEAD"]
  },
  "auth.ecoid.disconnect": {
    "uri": "auth\/ecoid\/disconnect\/{user}",
    "methods": ["DELETE"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.root": {
    "uri": "api",
    "methods": ["GET", "HEAD"]
  },
  "api.workaround.play": {
    "uri": "api\/play\/session\/{session}",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["session"]
  },
  "api.web.countries": {
    "uri": "api\/web\/countries",
    "methods": ["GET", "HEAD"]
  },
  "api.web.languages": {
    "uri": "api\/web\/languages",
    "methods": ["GET", "HEAD"]
  },
  "api.web.user.exists": {
    "uri": "api\/web\/user\/exists",
    "methods": ["GET", "HEAD"]
  },
  "api.web.account.exists": {
    "uri": "api\/web\/account\/exists",
    "methods": ["GET", "HEAD"]
  },
  "api.web.companies": {
    "uri": "api\/web\/company\/search",
    "methods": ["GET", "HEAD"]
  },
  "api.web.auth.check.username": {
    "uri": "api\/web\/auth\/check\/username\/{username}",
    "methods": ["GET", "HEAD"],
    "parameters": ["username"]
  },
  "api.web.auth.check.invite": {
    "uri": "api\/web\/auth\/check\/invite\/{invite}",
    "methods": ["GET", "HEAD"],
    "parameters": ["invite"]
  },
  "api.web.auth.check.email": {
    "uri": "api\/web\/auth\/check\/email\/{email}",
    "methods": ["GET", "HEAD"],
    "parameters": ["email"]
  },
  "api.web.auth.login": {
    "uri": "api\/web\/auth\/login",
    "methods": ["POST"]
  },
  "api.web.auth.register": {
    "uri": "api\/web\/auth\/register",
    "methods": ["POST"]
  },
  "api.web.auth.recover": {
    "uri": "api\/web\/auth\/recover\/{username}",
    "methods": ["POST"],
    "parameters": ["username"]
  },
  "api.web.auth.reset": {
    "uri": "api\/web\/auth\/reset\/{token}",
    "methods": ["POST"],
    "parameters": ["token"]
  },
  "api.web.auth.validate.profile": {
    "uri": "api\/web\/auth\/validate\/profile",
    "methods": ["POST"]
  },
  "api.web.auth.forget": {
    "uri": "api\/web\/auth\/forget",
    "methods": ["DELETE"]
  },
  "api.web.auth.invite.accept": {
    "uri": "api\/web\/auth\/invites\/{invite}",
    "methods": ["POST"],
    "parameters": ["invite"],
    "bindings": {
      "invite": "uuid"
    }
  },
  "api.web.auth.invite.decline": {
    "uri": "api\/web\/auth\/invites\/{invite}",
    "methods": ["DELETE"],
    "parameters": ["invite"],
    "bindings": {
      "invite": "uuid"
    }
  },
  "api.web.shop.admin.products": {
    "uri": "api\/web\/shop\/{shop}\/admin\/products",
    "methods": ["GET", "HEAD"],
    "parameters": ["shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.admin.product.update": {
    "uri": "api\/web\/shop\/{shop}\/admin\/products\/{product}",
    "methods": ["PUT"],
    "parameters": ["shop", "product"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.region.change": {
    "uri": "api\/web\/shop\/{shop}\/region",
    "methods": ["POST"],
    "parameters": ["shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.salespeople": {
    "uri": "api\/web\/shop\/{shop}\/salespeople",
    "methods": ["GET", "HEAD"],
    "parameters": ["shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.customer": {
    "uri": "api\/web\/shop\/{shop}\/customers\/{company}",
    "methods": ["GET", "HEAD"],
    "parameters": ["shop", "company"],
    "bindings": {
      "shop": "slug",
      "company": "id"
    }
  },
  "api.web.shop.products": {
    "uri": "api\/web\/shop\/{shop}\/products",
    "methods": ["GET", "HEAD"],
    "parameters": ["shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.product": {
    "uri": "api\/web\/shop\/{shop}\/products\/{product}",
    "methods": ["GET", "HEAD"],
    "parameters": ["shop", "product"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.product.subscribe": {
    "uri": "api\/web\/shop\/{shop}\/products\/{product}\/subscribe",
    "methods": ["POST"],
    "parameters": ["shop", "product"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.product.unsubscribe": {
    "uri": "api\/web\/shop\/{shop}\/products\/{product}\/unsubscribe",
    "methods": ["DELETE"],
    "parameters": ["shop", "product"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.cart": {
    "uri": "api\/web\/shop\/{shop}\/cart",
    "methods": ["GET", "HEAD"],
    "parameters": ["shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.cart.add": {
    "uri": "api\/web\/shop\/{shop}\/cart\/{product}",
    "methods": ["POST"],
    "parameters": ["shop", "product"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.cart.set": {
    "uri": "api\/web\/shop\/{shop}\/cart\/{product}\/{session?}",
    "methods": ["PUT"],
    "parameters": ["shop", "product", "session"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.cart.clear": {
    "uri": "api\/web\/shop\/{shop}\/cart",
    "methods": ["DELETE"],
    "parameters": ["shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "api.web.shop.checkout": {
    "uri": "api\/web\/shop\/{shop}\/checkout",
    "methods": ["GET", "HEAD"],
    "parameters": ["shop"]
  },
  "api.web.shop.checkout.update.company": {
    "uri": "api\/web\/shop\/{shop}\/checkout\/company",
    "methods": ["PUT"],
    "parameters": ["shop"]
  },
  "api.web.shop.checkout.update.enrollment": {
    "uri": "api\/web\/shop\/{shop}\/checkout\/enrollment",
    "methods": ["PUT"],
    "parameters": ["shop"]
  },
  "api.web.shop.checkout.update.payment": {
    "uri": "api\/web\/shop\/{shop}\/checkout\/payment",
    "methods": ["PUT"],
    "parameters": ["shop"]
  },
  "api.web.shop.checkout.confirm": {
    "uri": "api\/web\/shop\/{shop}\/checkout\/confirm",
    "methods": ["POST"],
    "parameters": ["shop"]
  },
  "api.web.shop.checkout.search": {
    "uri": "api\/web\/shop\/{shop}\/checkout\/search",
    "methods": ["GET", "HEAD"],
    "parameters": ["shop"]
  },
  "api.web.audits": {
    "uri": "api\/web\/audit",
    "methods": ["GET", "HEAD"]
  },
  "api.web.audits.context": {
    "uri": "api\/web\/audit\/{type}\/{id}",
    "methods": ["GET", "HEAD"],
    "parameters": ["type", "id"]
  },
  "api.web.mobile": {
    "uri": "api\/web\/mobile",
    "methods": ["GET", "HEAD"]
  },
  "api.web.mobile.submit": {
    "uri": "api\/web\/mobile\/submit",
    "methods": ["POST"]
  },
  "api.web.mobile.verify": {
    "uri": "api\/web\/mobile\/verify",
    "methods": ["POST"]
  },
  "api.web.integration": {
    "uri": "api\/web\/integrations\/{integration}",
    "methods": ["GET", "HEAD"],
    "parameters": ["integration"],
    "bindings": {
      "integration": "id"
    }
  },
  "api.web.integration.mode": {
    "uri": "api\/web\/integrations\/{integration}\/mode\/{mode}",
    "methods": ["PUT"],
    "parameters": ["integration", "mode"],
    "bindings": {
      "integration": "id"
    }
  },
  "api.web.integration.options": {
    "uri": "api\/web\/integrations\/{integration}\/options",
    "methods": ["PUT"],
    "parameters": ["integration"],
    "bindings": {
      "integration": "id"
    }
  },
  "api.web.integration.actions": {
    "uri": "api\/web\/integrations\/{integration}\/actions",
    "methods": ["GET", "HEAD"],
    "parameters": ["integration"],
    "bindings": {
      "integration": "id"
    }
  },
  "api.web.integration.actions.trigger": {
    "uri": "api\/web\/integrations\/{integration}\/actions",
    "methods": ["POST"],
    "parameters": ["integration"],
    "bindings": {
      "integration": "id"
    }
  },
  "api.web.integration.action": {
    "uri": "api\/web\/integrations\/{integration}\/actions\/{action}",
    "methods": ["GET", "HEAD"],
    "parameters": ["integration", "action"],
    "bindings": {
      "integration": "id",
      "action": "ulid"
    }
  },
  "api.web.integration.action.events": {
    "uri": "api\/web\/integrations\/{integration}\/actions\/{action}\/events",
    "methods": ["GET", "HEAD"],
    "parameters": ["integration", "action"],
    "bindings": {
      "integration": "id",
      "action": "ulid"
    }
  },
  "api.web.integration.action.retry": {
    "uri": "api\/web\/integrations\/{integration}\/actions\/{action}\/retry",
    "methods": ["POST"],
    "parameters": ["integration", "action"],
    "bindings": {
      "integration": "id",
      "action": "ulid"
    }
  },
  "api.web.integration.action.cancel": {
    "uri": "api\/web\/integrations\/{integration}\/actions\/{action}\/cancel",
    "methods": ["POST"],
    "parameters": ["integration", "action"],
    "bindings": {
      "integration": "id",
      "action": "ulid"
    }
  },
  "api.web.integration.request": {
    "uri": "api\/web\/integrations\/{integration}\/requests\/{request}",
    "methods": ["GET", "HEAD"],
    "parameters": ["integration", "request"],
    "bindings": {
      "integration": "id",
      "request": "ulid"
    }
  },
  "api.web.user.counters": {
    "uri": "api\/web\/user\/counters",
    "methods": ["GET", "HEAD"]
  },
  "api.web.user.employ": {
    "uri": "api\/web\/user\/employ",
    "methods": ["POST"]
  },
  "api.web.user.access": {
    "uri": "api\/web\/user\/access",
    "methods": ["GET", "HEAD"]
  },
  "api.web.user.access.browse": {
    "uri": "api\/web\/user\/access\/browse",
    "methods": ["GET", "HEAD"]
  },
  "api.web.user.access.browse.zones": {
    "uri": "api\/web\/user\/access\/browse\/{company}",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.user.access.enrollment": {
    "uri": "api\/web\/user\/access\/enrollment\/{company}",
    "methods": ["POST"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.user.access.company": {
    "uri": "api\/web\/user\/access\/company\/{company}",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.user.access.register": {
    "uri": "api\/web\/user\/access\/company\/{company}\/{zone}",
    "methods": ["POST"],
    "parameters": ["company", "zone"]
  },
  "api.web.user.access.unregister": {
    "uri": "api\/web\/user\/access\/company\/{company}\/{zone}",
    "methods": ["DELETE"],
    "parameters": ["company", "zone"]
  },
  "api.web.user.access.checkout": {
    "uri": "api\/web\/user\/access\/checkout\/{requirement}",
    "methods": ["POST"],
    "parameters": ["requirement"],
    "bindings": {
      "requirement": "id"
    }
  },
  "api.web.user.courses": {
    "uri": "api\/web\/user\/courses",
    "methods": ["GET", "HEAD"]
  },
  "api.web.user.course": {
    "uri": "api\/web\/user\/courses\/{course}\/{context?}",
    "methods": ["GET", "HEAD"],
    "parameters": ["course", "context"]
  },
  "api.web.user.course.launch": {
    "uri": "api\/web\/user\/courses\/{course}\/{context?}",
    "methods": ["POST"],
    "parameters": ["course", "context"]
  },
  "api.web.user.course.approve": {
    "uri": "api\/web\/user\/courses\/{course}\/approve",
    "methods": ["POST"],
    "parameters": ["course"]
  },
  "api.web.user.course.document": {
    "uri": "api\/web\/user\/courses\/{course}\/document",
    "methods": ["POST"],
    "parameters": ["course"]
  },
  "api.web.user.course.restart": {
    "uri": "api\/web\/user\/courses\/{course}\/restart",
    "methods": ["POST"],
    "parameters": ["course"]
  },
  "api.web.user.course.setdate": {
    "uri": "api\/web\/user\/courses\/{course}\/setdate",
    "methods": ["POST"],
    "parameters": ["course"]
  },
  "api.web.user.course.enroll": {
    "uri": "api\/web\/user\/courses\/{course}\/enroll",
    "methods": ["POST"],
    "parameters": ["course"]
  },
  "api.web.user.course.unenroll": {
    "uri": "api\/web\/user\/courses\/{course}\/unenroll",
    "methods": ["POST"],
    "parameters": ["course"]
  },
  "api.web.user.profile": {
    "uri": "api\/web\/user\/profile",
    "methods": ["GET", "HEAD"]
  },
  "api.web.user.profile.password": {
    "uri": "api\/web\/user\/profile\/password",
    "methods": ["POST"]
  },
  "api.web.user.profile.validate": {
    "uri": "api\/web\/user\/profile",
    "methods": ["POST"]
  },
  "api.web.user.profile.update": {
    "uri": "api\/web\/user\/profile",
    "methods": ["PATCH"]
  },
  "api.web.user.certificate": {
    "uri": "api\/web\/user\/certificate",
    "methods": ["GET", "HEAD"]
  },
  "api.web.user.certificate.add": {
    "uri": "api\/web\/user\/certificate",
    "methods": ["POST"]
  },
  "api.web.user.certificate.delete": {
    "uri": "api\/web\/user\/certificate\/{id}",
    "methods": ["DELETE"],
    "parameters": ["id"]
  },
  "api.web.user.certificate.addable": {
    "uri": "api\/web\/user\/certificate\/addable",
    "methods": ["GET", "HEAD"]
  },
  "api.web.user.session.enroll": {
    "uri": "api\/web\/user\/sessions\/{session}",
    "methods": ["POST"],
    "parameters": ["session"],
    "bindings": {
      "session": "id"
    }
  },
  "api.web.user.session.unenroll": {
    "uri": "api\/web\/user\/sessions\/{session}",
    "methods": ["DELETE"],
    "parameters": ["session"],
    "bindings": {
      "session": "id"
    }
  },
  "lms.user.gdpr": {
    "uri": "api\/web\/user\/gdpr",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.gdpr.request": {
    "uri": "api\/web\/user\/gdpr\/request",
    "methods": ["POST"]
  },
  "lms.user.gdpr.download": {
    "uri": "api\/web\/user\/gdpr\/download",
    "methods": ["POST"]
  },
  "api.web.access.gate": {
    "uri": "api\/web\/access\/gates\/{gate}",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.update": {
    "uri": "api\/web\/access\/gates\/{gate}",
    "methods": ["PUT"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.visibility.update": {
    "uri": "api\/web\/access\/gates\/{gate}\/visibility",
    "methods": ["PUT"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.zones": {
    "uri": "api\/web\/access\/gates\/{gate}\/zones",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.entrypoints": {
    "uri": "api\/web\/access\/gates\/{gate}\/entrypoints",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.entrypoint": {
    "uri": "api\/web\/access\/gates\/{gate}\/entrypoints\/{entrypoint}",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate", "entrypoint"],
    "bindings": {
      "gate": "id",
      "entrypoint": "id"
    }
  },
  "api.web.access.gate.entrypoint.update": {
    "uri": "api\/web\/access\/gates\/{gate}\/entrypoints\/{entrypoint}",
    "methods": ["PUT"],
    "parameters": ["gate", "entrypoint"],
    "bindings": {
      "gate": "id",
      "entrypoint": "id"
    }
  },
  "api.web.access.gate.links": {
    "uri": "api\/web\/access\/gates\/{gate}\/links",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.links.create": {
    "uri": "api\/web\/access\/gates\/{gate}\/links",
    "methods": ["POST"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.link.update": {
    "uri": "api\/web\/access\/gates\/{gate}\/links\/{link}",
    "methods": ["POST"],
    "parameters": ["gate", "link"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.link.delete": {
    "uri": "api\/web\/access\/gates\/{gate}\/links\/{link}",
    "methods": ["DELETE"],
    "parameters": ["gate", "link"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.cards": {
    "uri": "api\/web\/access\/gates\/{gate}\/cards",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.card": {
    "uri": "api\/web\/access\/gates\/{gate}\/cards\/{card}",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate", "card"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.card.search": {
    "uri": "api\/web\/access\/gates\/{gate}\/cards\/{card}\/search",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate", "card"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.card.match": {
    "uri": "api\/web\/access\/gates\/{gate}\/cards\/{card}\/match",
    "methods": ["POST"],
    "parameters": ["gate", "card"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.user.enroll": {
    "uri": "api\/web\/access\/gates\/{gate}\/user\/enroll",
    "methods": ["POST"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.user.status": {
    "uri": "api\/web\/access\/gates\/{gate}\/user\/{user}\/status",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate", "user"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.user.internal": {
    "uri": "api\/web\/access\/gates\/{gate}\/user\/{user}\/internal\/{internal}",
    "methods": ["PUT"],
    "parameters": ["gate", "user", "internal"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.user.company": {
    "uri": "api\/web\/access\/gates\/{gate}\/user\/{user}\/company",
    "methods": ["PUT"],
    "parameters": ["gate", "user"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.user.responsible": {
    "uri": "api\/web\/access\/gates\/{gate}\/user\/{user}\/responsible\/{responsible}",
    "methods": ["PUT"],
    "parameters": ["gate", "user", "responsible"],
    "bindings": {
      "gate": "id",
      "responsible": "id"
    }
  },
  "api.web.access.gate.user.responsible.unset": {
    "uri": "api\/web\/access\/gates\/{gate}\/user\/{user}\/responsible",
    "methods": ["DELETE"],
    "parameters": ["gate", "user"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.user.card": {
    "uri": "api\/web\/access\/gates\/{gate}\/user\/{user}\/card\/{card}",
    "methods": ["PUT"],
    "parameters": ["gate", "user", "card"]
  },
  "api.web.access.gate.responsibles": {
    "uri": "api\/web\/access\/gates\/{gate}\/responsibles",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.responsible.add": {
    "uri": "api\/web\/access\/gates\/{gate}\/responsibles",
    "methods": ["POST"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.responsible.update": {
    "uri": "api\/web\/access\/gates\/{gate}\/responsibles\/{company}",
    "methods": ["PUT"],
    "parameters": ["gate", "company"],
    "bindings": {
      "gate": "id",
      "company": "id"
    }
  },
  "api.web.access.gate.responsible.remove": {
    "uri": "api\/web\/access\/gates\/{gate}\/responsibles\/{company}",
    "methods": ["DELETE"],
    "parameters": ["gate", "company"],
    "bindings": {
      "gate": "id",
      "company": "id"
    }
  },
  "api.web.access.gate.requisitions": {
    "uri": "api\/web\/access\/gates\/{gate}\/requisitions",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.requisition.create": {
    "uri": "api\/web\/access\/gates\/{gate}\/requisitions",
    "methods": ["POST"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.requisition": {
    "uri": "api\/web\/access\/gates\/{gate}\/requisitions\/{requisition}",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate", "requisition"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.requisition.review": {
    "uri": "api\/web\/access\/gates\/{gate}\/requisitions\/{requisition}",
    "methods": ["PUT"],
    "parameters": ["gate", "requisition"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.requisition.delete": {
    "uri": "api\/web\/access\/gates\/{gate}\/requisitions\/{requisition}",
    "methods": ["DELETE"],
    "parameters": ["gate", "requisition"]
  },
  "api.web.access.gate.search.users": {
    "uri": "api\/web\/access\/gates\/{gate}\/search\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "api.web.access.gate.companies.update": {
    "uri": "api\/web\/access\/gates\/{gate}\/companies\/{company}",
    "methods": ["PUT"],
    "parameters": ["gate", "company"],
    "bindings": {
      "gate": "id",
      "company": "id"
    }
  },
  "api.web.access.zone": {
    "uri": "api\/web\/access\/zones\/{zone}",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.update": {
    "uri": "api\/web\/access\/zones\/{zone}",
    "methods": ["PUT"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.create": {
    "uri": "api\/web\/access\/zones\/{zone}\/create",
    "methods": ["POST"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.users": {
    "uri": "api\/web\/access\/zones\/{zone}\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone", "user"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.requisitions": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/requisitions",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone", "user"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.patch": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}",
    "methods": ["PATCH"],
    "parameters": ["zone", "user"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.sync": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/sync",
    "methods": ["POST"],
    "parameters": ["zone", "user"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.unregister": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}",
    "methods": ["DELETE"],
    "parameters": ["zone", "user"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.unrequisition": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/requisition\/{requisition}",
    "methods": ["DELETE"],
    "parameters": ["zone", "user", "requisition"],
    "bindings": {
      "zone": "id",
      "requisition": "id"
    }
  },
  "api.web.access.zone.user.course": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/courses\/{course}",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone", "user", "course"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.course.restart": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/courses\/{course}\/restart",
    "methods": ["POST"],
    "parameters": ["zone", "user", "course"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.course.cancel": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/courses\/{course}\/cancel",
    "methods": ["POST"],
    "parameters": ["zone", "user", "course"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.course.document": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/courses\/{course}\/document",
    "methods": ["POST"],
    "parameters": ["zone", "user", "course"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.course.setdate": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/courses\/{course}\/setdate",
    "methods": ["POST"],
    "parameters": ["zone", "user", "course"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.course.approve": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/courses\/{course}\/approve",
    "methods": ["POST"],
    "parameters": ["zone", "user", "course"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.user.course.reject": {
    "uri": "api\/web\/access\/zones\/{zone}\/users\/{user}\/courses\/{course}\/reject",
    "methods": ["POST"],
    "parameters": ["zone", "user", "course"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.search.admins": {
    "uri": "api\/web\/access\/zones\/{zone}\/search\/admins",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.search.companies": {
    "uri": "api\/web\/access\/zones\/{zone}\/search\/companies",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.search.users": {
    "uri": "api\/web\/access\/zones\/{zone}\/search\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.requirements": {
    "uri": "api\/web\/access\/zones\/{zone}\/requirements",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.requirements.course.add": {
    "uri": "api\/web\/access\/zones\/{zone}\/requirements\/{course}",
    "methods": ["POST"],
    "parameters": ["zone", "course"],
    "bindings": {
      "zone": "id",
      "course": "id"
    }
  },
  "api.web.access.zone.requirements.course.module.add": {
    "uri": "api\/web\/access\/zones\/{zone}\/requirements\/{course}\/{object}",
    "methods": ["POST"],
    "parameters": ["zone", "course", "object"],
    "bindings": {
      "zone": "id",
      "course": "id",
      "object": "id"
    }
  },
  "api.web.access.zone.requirements.course.remove": {
    "uri": "api\/web\/access\/zones\/{zone}\/requirements\/{course}",
    "methods": ["DELETE"],
    "parameters": ["zone", "course"],
    "bindings": {
      "zone": "id",
      "course": "id"
    }
  },
  "api.web.access.zone.requirements.course.module.remove": {
    "uri": "api\/web\/access\/zones\/{zone}\/requirements\/{course}\/{object}",
    "methods": ["DELETE"],
    "parameters": ["zone", "course", "object"],
    "bindings": {
      "zone": "id",
      "course": "id",
      "object": "id"
    }
  },
  "api.web.access.zone.certificates": {
    "uri": "api\/web\/access\/zones\/{zone}\/certificates",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.certificate.add": {
    "uri": "api\/web\/access\/zones\/{zone}\/certificates\/{type}",
    "methods": ["POST"],
    "parameters": ["zone", "type"],
    "bindings": {
      "zone": "id",
      "type": "id"
    }
  },
  "api.web.access.zone.certificate.remove": {
    "uri": "api\/web\/access\/zones\/{zone}\/certificates\/{type}",
    "methods": ["DELETE"],
    "parameters": ["zone", "type"],
    "bindings": {
      "zone": "id",
      "type": "id"
    }
  },
  "api.web.access.zone.admins": {
    "uri": "api\/web\/access\/zones\/{zone}\/admins",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.admin.add": {
    "uri": "api\/web\/access\/zones\/{zone}\/admins",
    "methods": ["POST"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.admin.update": {
    "uri": "api\/web\/access\/zones\/{zone}\/admins\/{user}",
    "methods": ["PUT"],
    "parameters": ["zone", "user"],
    "bindings": {
      "zone": "id",
      "user": "id"
    }
  },
  "api.web.access.zone.admin.remove": {
    "uri": "api\/web\/access\/zones\/{zone}\/admins\/{user}",
    "methods": ["DELETE"],
    "parameters": ["zone", "user"],
    "bindings": {
      "zone": "id",
      "user": "id"
    }
  },
  "api.web.access.zone.entrypoints": {
    "uri": "api\/web\/access\/zones\/{zone}\/entrypoints",
    "methods": ["GET", "HEAD"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.access.zone.entrypoints.set": {
    "uri": "api\/web\/access\/zones\/{zone}\/entrypoints",
    "methods": ["PUT"],
    "parameters": ["zone"],
    "bindings": {
      "zone": "id"
    }
  },
  "api.web.attempt": {
    "uri": "api\/web\/attempt\/{attempt}",
    "methods": ["GET", "HEAD"],
    "parameters": ["attempt"]
  },
  "api.web.attempt.diploma.send": {
    "uri": "api\/web\/attempt\/{attempt}\/diploma\/send",
    "methods": ["POST"],
    "parameters": ["attempt"]
  },
  "api.web.attempt.language.update": {
    "uri": "api\/web\/attempt\/{attempt}\/language",
    "methods": ["POST"],
    "parameters": ["attempt"]
  },
  "api.web.attempt.condition.update": {
    "uri": "api\/web\/attempt\/{attempt}\/condition",
    "methods": ["POST"],
    "parameters": ["attempt"]
  },
  "api.web.attempt.auth.reject": {
    "uri": "api\/web\/attempt\/{attempt}\/auth\/reject",
    "methods": ["POST"],
    "parameters": ["attempt"]
  },
  "api.web.attempt.auth.confirm": {
    "uri": "api\/web\/attempt\/{attempt}\/auth\/confirm",
    "methods": ["POST"],
    "parameters": ["attempt"]
  },
  "api.web.attempt.node": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.course.start": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/course\/start",
    "methods": ["POST"],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.session.enroll": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/session\/{session}",
    "methods": ["POST"],
    "parameters": ["attempt", "node", "session"],
    "bindings": {
      "session": "id"
    }
  },
  "api.web.attempt.node.session.unenroll": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/session\/{session}",
    "methods": ["DELETE"],
    "parameters": ["attempt", "node", "session"],
    "bindings": {
      "session": "id"
    }
  },
  "api.web.attempt.node.file.download": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/file\/download",
    "methods": ["GET", "HEAD"],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.document": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/document",
    "methods": ["POST"],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.approve": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/approve",
    "methods": ["POST"],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.link": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/link",
    "methods": ["GET", "HEAD"],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.video.progress": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/video\/progress",
    "methods": ["POST"],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.scorm.initialize": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/scorm\/{item}",
    "methods": ["GET", "HEAD"],
    "parameters": ["attempt", "node", "item"]
  },
  "api.web.attempt.node.scorm.commit": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/scorm\/{item}",
    "methods": ["POST"],
    "parameters": ["attempt", "node", "item"]
  },
  "api.web.attempt.node.quiz.answer": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/quiz\/answer",
    "methods": ["POST"],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.quiz.restart": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/quiz\/restart",
    "methods": ["POST"],
    "parameters": ["attempt", "node"]
  },
  "api.web.attempt.node.quiz.timer": {
    "uri": "api\/web\/attempt\/{attempt}\/nodes\/{node}\/quiz\/timer",
    "methods": ["POST"],
    "parameters": ["attempt", "node"]
  },
  "api.web.admin.check.email": {
    "uri": "api\/web\/check\/{email}",
    "methods": ["GET", "HEAD"],
    "parameters": ["email"]
  },
  "api.web.admin.link.info": {
    "uri": "api\/web\/link\/info",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.duration.seconds": {
    "uri": "api\/web\/duration\/seconds\/{seconds}",
    "methods": ["GET", "HEAD"],
    "parameters": ["seconds"]
  },
  "api.web.admin.approvals": {
    "uri": "api\/web\/approvals",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.approval": {
    "uri": "api\/web\/approvals\/{approval}",
    "methods": ["GET", "HEAD"],
    "parameters": ["approval"]
  },
  "api.web.admin.approval.review": {
    "uri": "api\/web\/approvals\/{approval}\/review",
    "methods": ["POST"],
    "parameters": ["approval"],
    "bindings": {
      "approval": "id"
    }
  },
  "api.web.admin.approval.document": {
    "uri": "api\/web\/approvals\/{approval}\/document",
    "methods": ["POST"],
    "parameters": ["approval"],
    "bindings": {
      "approval": "id"
    }
  },
  "api.web.admin.approval.validity": {
    "uri": "api\/web\/approvals\/{approval}\/validity",
    "methods": ["POST"],
    "parameters": ["approval"],
    "bindings": {
      "approval": "id"
    }
  },
  "api.web.admin.course-revenue": {
    "uri": "api\/web\/course-revenue",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.course-revenue.export": {
    "uri": "api\/web\/course-revenue\/export",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.companies": {
    "uri": "api\/web\/companies",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.companies.create": {
    "uri": "api\/web\/companies",
    "methods": ["POST"]
  },
  "api.web.admin.company": {
    "uri": "api\/web\/companies\/{company}",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.update": {
    "uri": "api\/web\/companies\/{company}",
    "methods": ["PUT"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.fetch": {
    "uri": "api\/web\/companies\/{company}\/fetch",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.context": {
    "uri": "api\/web\/companies\/{company}\/context",
    "methods": ["POST"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.address.save": {
    "uri": "api\/web\/companies\/{company}\/addresses",
    "methods": ["PUT"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.address.delete": {
    "uri": "api\/web\/companies\/{company}\/addresses\/{address}",
    "methods": ["DELETE"],
    "parameters": ["company", "address"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.domains.save": {
    "uri": "api\/web\/companies\/{company}\/domains",
    "methods": ["PUT"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.charts.users": {
    "uri": "api\/web\/companies\/{company}\/charts\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.charts.completions": {
    "uri": "api\/web\/companies\/{company}\/charts\/completions",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.admin.company.courses": {
    "uri": "api\/web\/company-courses",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.company.course": {
    "uri": "api\/web\/company-courses\/{companyCourse}",
    "methods": ["GET", "HEAD"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.settings.update": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/settings",
    "methods": ["PUT"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.users": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.completion": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/completion",
    "methods": ["POST"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.stats": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/stats",
    "methods": ["GET", "HEAD"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.enrollments": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/enrollments",
    "methods": ["GET", "HEAD"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.enrollments.enroll": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/enrollments",
    "methods": ["POST"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.enrollments.unenroll": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/enrollments",
    "methods": ["DELETE"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.enrollments.update": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/enrollments\/{enrollment}",
    "methods": ["POST"],
    "parameters": ["companyCourse", "enrollment"],
    "bindings": {
      "companyCourse": "id",
      "enrollment": "id"
    }
  },
  "api.web.admin.company.course.sessions": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions",
    "methods": ["GET", "HEAD"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.create": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions",
    "methods": ["POST"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}",
    "methods": ["GET", "HEAD"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.update": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}",
    "methods": ["POST"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.open": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}\/open",
    "methods": ["POST"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.close": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}\/close",
    "methods": ["POST"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.toggle": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}\/toggle",
    "methods": ["POST"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.move": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}\/move",
    "methods": ["POST"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.participants": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}\/participants",
    "methods": ["GET", "HEAD"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.users.update": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}\/users",
    "methods": ["POST"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.session.users.unenroll": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/sessions\/{session}\/users",
    "methods": ["DELETE"],
    "parameters": ["companyCourse", "session"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.sessions.requests": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/session-requests",
    "methods": ["GET", "HEAD"],
    "parameters": ["companyCourse"],
    "bindings": {
      "companyCourse": "id"
    }
  },
  "api.web.admin.company.course.sessions.requests.delete": {
    "uri": "api\/web\/company-courses\/{companyCourse}\/session-requests\/{sessionRequest}",
    "methods": ["DELETE"],
    "parameters": ["companyCourse", "sessionRequest"],
    "bindings": {
      "companyCourse": "id",
      "sessionRequest": "id"
    }
  },
  "api.web.admin.courses": {
    "uri": "api\/web\/courses",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.courses.create": {
    "uri": "api\/web\/courses",
    "methods": ["POST"]
  },
  "api.web.admin.course.show": {
    "uri": "api\/web\/courses\/{course}",
    "methods": ["GET", "HEAD"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "api.web.admin.course.update": {
    "uri": "api\/web\/courses\/{course}",
    "methods": ["POST"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "api.web.admin.course.image.update": {
    "uri": "api\/web\/courses\/{course}\/image",
    "methods": ["POST"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "api.web.admin.course.quiz.generate": {
    "uri": "api\/web\/courses\/{course}\/quiz",
    "methods": ["POST"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "api.web.admin.course.revert": {
    "uri": "api\/web\/courses\/{course}\/revert",
    "methods": ["POST"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "api.web.admin.course.publish": {
    "uri": "api\/web\/courses\/{course}\/publish",
    "methods": ["POST"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "api.web.admin.course.publish-globally": {
    "uri": "api\/web\/courses\/{course}\/publish-globally",
    "methods": ["POST"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "api.web.admin.roles": {
    "uri": "api\/web\/roles",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.role.create": {
    "uri": "api\/web\/roles",
    "methods": ["POST"]
  },
  "api.web.admin.role": {
    "uri": "api\/web\/roles\/{role}",
    "methods": ["GET", "HEAD"],
    "parameters": ["role"]
  },
  "api.web.admin.role.update": {
    "uri": "api\/web\/roles\/{role}",
    "methods": ["POST"],
    "parameters": ["role"]
  },
  "api.web.admin.role.delete": {
    "uri": "api\/web\/roles\/{role}",
    "methods": ["DELETE"],
    "parameters": ["role"]
  },
  "api.web.admin.role.users": {
    "uri": "api\/web\/roles\/{role}\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["role"]
  },
  "api.web.admin.role.users.search": {
    "uri": "api\/web\/roles\/{role}\/users\/search",
    "methods": ["GET", "HEAD"],
    "parameters": ["role"]
  },
  "api.web.admin.role.users.add": {
    "uri": "api\/web\/roles\/{role}\/users",
    "methods": ["POST"],
    "parameters": ["role"]
  },
  "api.web.admin.role.users.remove": {
    "uri": "api\/web\/roles\/{role}\/users",
    "methods": ["DELETE"],
    "parameters": ["role"]
  },
  "api.web.admin.role.courses": {
    "uri": "api\/web\/roles\/{role}\/courses",
    "methods": ["GET", "HEAD"],
    "parameters": ["role"]
  },
  "api.web.admin.role.courses.add": {
    "uri": "api\/web\/roles\/{role}\/courses",
    "methods": ["POST"],
    "parameters": ["role"]
  },
  "api.web.admin.role.courses.remove": {
    "uri": "api\/web\/roles\/{role}\/courses",
    "methods": ["DELETE"],
    "parameters": ["role"]
  },
  "api.web.admin.users": {
    "uri": "api\/web\/users",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.users.remove": {
    "uri": "api\/web\/users",
    "methods": ["DELETE"]
  },
  "api.web.admin.users.assign.roles": {
    "uri": "api\/web\/users\/roles",
    "methods": ["POST"]
  },
  "api.web.admin.users.assign.courses": {
    "uri": "api\/web\/users\/courses",
    "methods": ["POST"]
  },
  "api.web.admin.user.remove": {
    "uri": "api\/web\/users\/{user}",
    "methods": ["DELETE"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.impersonate": {
    "uri": "api\/web\/users\/{user}\/impersonate",
    "methods": ["POST"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.certificate": {
    "uri": "api\/web\/users\/{user}\/certificate",
    "methods": ["POST"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.companies": {
    "uri": "api\/web\/users\/{user}\/companies",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.companies.maintain": {
    "uri": "api\/web\/users\/{user}\/companies",
    "methods": ["PUT"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.company.update": {
    "uri": "api\/web\/users\/{user}\/companies\/{company}",
    "methods": ["POST"],
    "parameters": ["user", "company"],
    "bindings": {
      "user": "id",
      "company": "id"
    }
  },
  "api.web.admin.user.company.remove": {
    "uri": "api\/web\/users\/{user}\/companies\/{company}",
    "methods": ["DELETE"],
    "parameters": ["user", "company"],
    "bindings": {
      "user": "id",
      "company": "id"
    }
  },
  "api.web.admin.user.company.employ": {
    "uri": "api\/web\/users\/{user}\/companies\/{company}\/employ",
    "methods": ["POST"],
    "parameters": ["user", "company"],
    "bindings": {
      "user": "id",
      "company": "id"
    }
  },
  "api.web.admin.user.company.restore": {
    "uri": "api\/web\/users\/{user}\/companies\/{company}\/restore",
    "methods": ["POST"],
    "parameters": ["user", "company"],
    "bindings": {
      "user": "id",
      "company": "id"
    }
  },
  "api.web.admin.user.courses": {
    "uri": "api\/web\/users\/{user}\/courses",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.courses.enrollable": {
    "uri": "api\/web\/users\/{user}\/courses\/enrollable",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/{context?}",
    "methods": ["GET", "HEAD"],
    "parameters": ["user", "course", "context"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course.restart": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/restart",
    "methods": ["POST"],
    "parameters": ["user", "course"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course.cancel": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/cancel",
    "methods": ["POST"],
    "parameters": ["user", "course"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course.document": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/document",
    "methods": ["POST"],
    "parameters": ["user", "course"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course.setdate": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/setdate",
    "methods": ["POST"],
    "parameters": ["user", "course"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course.approve": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/approve",
    "methods": ["POST"],
    "parameters": ["user", "course"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course.reject": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/reject",
    "methods": ["POST"],
    "parameters": ["user", "course"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course.enroll": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/{company_course}",
    "methods": ["PUT"],
    "parameters": ["user", "course", "company_course"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.course.unenroll": {
    "uri": "api\/web\/users\/{user}\/courses\/{course}\/{company_course}",
    "methods": ["DELETE"],
    "parameters": ["user", "course", "company_course"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.roles": {
    "uri": "api\/web\/users\/{user}\/roles",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.admin.user.role.enroll": {
    "uri": "api\/web\/users\/{user}\/roles\/{role}",
    "methods": ["POST"],
    "parameters": ["user", "role"],
    "bindings": {
      "user": "id",
      "role": "id"
    }
  },
  "api.web.admin.user.role.unenroll": {
    "uri": "api\/web\/users\/{user}\/roles\/{role}",
    "methods": ["DELETE"],
    "parameters": ["user", "role"],
    "bindings": {
      "user": "id",
      "role": "id"
    }
  },
  "api.web.admin.import.users": {
    "uri": "api\/web\/import\/users",
    "methods": ["POST"]
  },
  "api.web.admin.import.users.batch": {
    "uri": "api\/web\/import\/users\/batch\/{batch}",
    "methods": ["GET", "HEAD"],
    "parameters": ["batch"]
  },
  "api.web.admin.import.users.batch.update": {
    "uri": "api\/web\/import\/users\/batch\/{batch}",
    "methods": ["POST"],
    "parameters": ["batch"]
  },
  "api.web.admin.import.users.batch.process": {
    "uri": "api\/web\/import\/users\/batch\/{batch}\/process",
    "methods": ["GET", "HEAD"],
    "parameters": ["batch"]
  },
  "api.web.admin.import.users.batch.delete": {
    "uri": "api\/web\/import\/users\/batch\/{batch}",
    "methods": ["DELETE"],
    "parameters": ["batch"],
    "bindings": {
      "batch": "uuid"
    }
  },
  "api.web.admin.locations": {
    "uri": "api\/web\/locations",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.locations.create": {
    "uri": "api\/web\/locations",
    "methods": ["POST"]
  },
  "api.web.admin.locations.map": {
    "uri": "api\/web\/locations\/map\/{size}",
    "methods": ["GET", "HEAD"],
    "parameters": ["size"]
  },
  "api.web.admin.locations.photo": {
    "uri": "api\/web\/locations\/photo\/{reference}",
    "methods": ["GET", "HEAD"],
    "parameters": ["reference"]
  },
  "api.web.admin.locations.search": {
    "uri": "api\/web\/locations\/search",
    "methods": ["GET", "HEAD"]
  },
  "api.web.admin.location.update": {
    "uri": "api\/web\/locations\/{location}",
    "methods": ["POST"],
    "parameters": ["location"]
  },
  "api.web.admin.department.root": {
    "uri": "api\/web\/departments",
    "methods": ["PATCH"]
  },
  "api.web.admin.department": {
    "uri": "api\/web\/departments\/{department}",
    "methods": ["GET", "HEAD"],
    "parameters": ["department"]
  },
  "api.web.admin.department.update": {
    "uri": "api\/web\/departments\/{department}",
    "methods": ["POST"],
    "parameters": ["department"]
  },
  "api.web.admin.department.create": {
    "uri": "api\/web\/departments\/{department}\/create",
    "methods": ["POST"],
    "parameters": ["department"]
  },
  "api.web.admin.department.add": {
    "uri": "api\/web\/departments\/{department}\/add",
    "methods": ["POST"],
    "parameters": ["department"]
  },
  "api.web.admin.department.move": {
    "uri": "api\/web\/departments\/{department}\/move",
    "methods": ["POST"],
    "parameters": ["department"]
  },
  "api.web.admin.department.detach": {
    "uri": "api\/web\/departments\/{department}\/detach",
    "methods": ["POST"],
    "parameters": ["department"]
  },
  "api.web.salesorders.create": {
    "uri": "api\/web\/orders",
    "methods": ["POST"]
  },
  "api.web.salesorder": {
    "uri": "api\/web\/orders\/{order}",
    "methods": ["GET", "HEAD"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "api.web.salesorder.update": {
    "uri": "api\/web\/orders\/{order}",
    "methods": ["POST"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "api.web.salesorder.delete": {
    "uri": "api\/web\/orders\/{order}",
    "methods": ["DELETE"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "api.web.salesorder.approve": {
    "uri": "api\/web\/orders\/{order}\/approve",
    "methods": ["POST"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "api.web.salesorder.bill": {
    "uri": "api\/web\/orders\/{order}\/bill",
    "methods": ["POST"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "api.web.salesorder.ledger": {
    "uri": "api\/web\/orders\/{order}\/ledger",
    "methods": ["POST"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "api.web.salesorder.duplicate": {
    "uri": "api\/web\/orders\/{order}\/duplicate",
    "methods": ["POST"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "api.web.oauth.scopes": {
    "uri": "api\/web\/oauth\/scopes",
    "methods": ["GET", "HEAD"]
  },
  "api.web.oauth.apps": {
    "uri": "api\/web\/oauth\/authorized-applications",
    "methods": ["GET", "HEAD"]
  },
  "api.web.oauth.app.delete": {
    "uri": "api\/web\/oauth\/authorized-applications\/{token}",
    "methods": ["DELETE"],
    "parameters": ["token"]
  },
  "api.web.oauth.pats": {
    "uri": "api\/web\/oauth\/personal-access-tokens",
    "methods": ["GET", "HEAD"]
  },
  "api.web.oauth.pat.create": {
    "uri": "api\/web\/oauth\/personal-access-tokens",
    "methods": ["POST"]
  },
  "api.web.oauth.pat.delete": {
    "uri": "api\/web\/oauth\/personal-access-tokens\/{token}",
    "methods": ["DELETE"],
    "parameters": ["token"]
  },
  "api.web.oauth.clients": {
    "uri": "api\/web\/oauth\/clients",
    "methods": ["GET", "HEAD"]
  },
  "api.web.oauth.client.create": {
    "uri": "api\/web\/oauth\/clients",
    "methods": ["POST"]
  },
  "api.web.oauth.client.update": {
    "uri": "api\/web\/oauth\/clients\/{client}",
    "methods": ["PUT"],
    "parameters": ["client"]
  },
  "api.web.oauth.client.delete": {
    "uri": "api\/web\/oauth\/clients\/{client}",
    "methods": ["DELETE"],
    "parameters": ["client"]
  },
  "api.web.oauth.client.tokens": {
    "uri": "api\/web\/oauth\/clients\/{client}\/tokens",
    "methods": ["GET", "HEAD"],
    "parameters": ["client"]
  },
  "api.web.oauth.client.token.create": {
    "uri": "api\/web\/oauth\/clients\/{client}\/tokens",
    "methods": ["POST"],
    "parameters": ["client"]
  },
  "api.web.oauth.client.token.delete": {
    "uri": "api\/web\/oauth\/clients\/{client}\/tokens\/{token}",
    "methods": ["DELETE"],
    "parameters": ["client", "token"]
  },
  "api.web.oauth.client.webhooks": {
    "uri": "api\/web\/oauth\/clients\/{client}\/webhooks",
    "methods": ["GET", "HEAD"],
    "parameters": ["client"]
  },
  "api.web.oauth.client.webhook.set": {
    "uri": "api\/web\/oauth\/clients\/{client}\/webhooks\/{name}",
    "methods": ["POST"],
    "parameters": ["client", "name"]
  },
  "api.web.oauth.client.webhook.test": {
    "uri": "api\/web\/oauth\/clients\/{client}\/webhooks\/{name}\/test",
    "methods": ["POST"],
    "parameters": ["client", "name"]
  },
  "api.web.oauth.client.webhook.remove": {
    "uri": "api\/web\/oauth\/clients\/{client}\/webhooks\/{name}",
    "methods": ["DELETE"],
    "parameters": ["client", "name"]
  },
  "api.web.oauth.client.accounts": {
    "uri": "api\/web\/oauth\/clients\/{client}\/accounts",
    "methods": ["GET", "HEAD"],
    "parameters": ["client"],
    "bindings": {
      "client": "id"
    }
  },
  "api.web.oauth.client.account.add": {
    "uri": "api\/web\/oauth\/clients\/{client}\/accounts",
    "methods": ["POST"],
    "parameters": ["client"],
    "bindings": {
      "client": "id"
    }
  },
  "api.web.oauth.client.account.remove": {
    "uri": "api\/web\/oauth\/clients\/{client}\/accounts\/{ulid}",
    "methods": ["DELETE"],
    "parameters": ["client", "ulid"],
    "bindings": {
      "client": "id"
    }
  },
  "api.web.oauth.client.courses.addable": {
    "uri": "api\/web\/oauth\/clients\/{client}\/addable\/courses",
    "methods": ["GET", "HEAD"],
    "parameters": ["client"],
    "bindings": {
      "client": "id"
    }
  },
  "api.web.oauth.client.courses": {
    "uri": "api\/web\/oauth\/clients\/{client}\/courses",
    "methods": ["GET", "HEAD"],
    "parameters": ["client"],
    "bindings": {
      "client": "id"
    }
  },
  "api.web.oauth.client.course.add": {
    "uri": "api\/web\/oauth\/clients\/{client}\/courses",
    "methods": ["POST"],
    "parameters": ["client"],
    "bindings": {
      "client": "id"
    }
  },
  "api.web.oauth.client.course.remove": {
    "uri": "api\/web\/oauth\/clients\/{client}\/courses\/{course}",
    "methods": ["DELETE"],
    "parameters": ["client", "course"],
    "bindings": {
      "client": "id",
      "course": "id"
    }
  },
  "api.web.munio.admins": {
    "uri": "api\/web\/munio\/admins",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.accounts.create": {
    "uri": "api\/web\/munio\/accounts",
    "methods": ["POST"]
  },
  "api.web.munio.account.show": {
    "uri": "api\/web\/munio\/accounts\/{id}",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "api.web.munio.account.update": {
    "uri": "api\/web\/munio\/accounts\/{id}",
    "methods": ["PUT"],
    "parameters": ["id"]
  },
  "api.web.munio.account.delete": {
    "uri": "api\/web\/munio\/accounts\/{id}",
    "methods": ["DELETE"],
    "parameters": ["id"]
  },
  "api.web.munio.account.update.info": {
    "uri": "api\/web\/munio\/accounts\/{id}\/info",
    "methods": ["POST"],
    "parameters": ["id"]
  },
  "api.web.munio.account.users": {
    "uri": "api\/web\/munio\/accounts\/{id}\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "api.web.munio.account.users.create": {
    "uri": "api\/web\/munio\/accounts\/{id}\/users",
    "methods": ["POST"],
    "parameters": ["id"]
  },
  "api.web.munio.account.users.delete": {
    "uri": "api\/web\/munio\/accounts\/{id}\/users\/{user}",
    "methods": ["DELETE"],
    "parameters": ["id", "user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.munio.companies": {
    "uri": "api\/web\/munio\/companies",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.company.users": {
    "uri": "api\/web\/munio\/companies\/{company}\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.munio.company.courses.addable": {
    "uri": "api\/web\/munio\/companies\/{company}\/courses-addable",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.munio.company.courses": {
    "uri": "api\/web\/munio\/companies\/{company}\/courses",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.munio.company.course.add": {
    "uri": "api\/web\/munio\/companies\/{company}\/courses",
    "methods": ["POST"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.munio.company.course.delete": {
    "uri": "api\/web\/munio\/companies\/{company}\/courses\/{course}",
    "methods": ["DELETE"],
    "parameters": ["company", "course"],
    "bindings": {
      "company": "id",
      "course": "id"
    }
  },
  "api.web.munio.company.course.restore": {
    "uri": "api\/web\/munio\/companies\/{company}\/courses\/{course}\/restore",
    "methods": ["POST"],
    "parameters": ["company", "course"],
    "bindings": {
      "company": "id",
      "course": "id"
    }
  },
  "api.web.munio.company.course.licenses": {
    "uri": "api\/web\/munio\/companies\/{company}\/courses\/{course}\/licenses",
    "methods": ["GET", "HEAD"],
    "parameters": ["company", "course"],
    "bindings": {
      "company": "id",
      "course": "id"
    }
  },
  "api.web.munio.company.course.licenses.update": {
    "uri": "api\/web\/munio\/companies\/{company}\/courses\/{course}\/licenses",
    "methods": ["PUT"],
    "parameters": ["company", "course"],
    "bindings": {
      "company": "id",
      "course": "id"
    }
  },
  "api.web.munio.company.access.gates": {
    "uri": "api\/web\/munio\/companies\/{company}\/access\/gates",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.munio.company.access.gate.create": {
    "uri": "api\/web\/munio\/companies\/{company}\/access\/gates",
    "methods": ["POST"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.munio.company.access.gate.delete": {
    "uri": "api\/web\/munio\/companies\/{company}\/access\/gates\/{gate}",
    "methods": ["DELETE"],
    "parameters": ["company", "gate"],
    "bindings": {
      "company": "id"
    }
  },
  "api.web.munio.courses": {
    "uri": "api\/web\/munio\/courses",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.course.update": {
    "uri": "api\/web\/munio\/courses\/{course}",
    "methods": ["PUT"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "api.web.munio.packages": {
    "uri": "api\/web\/munio\/packages",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.packages.create": {
    "uri": "api\/web\/munio\/packages",
    "methods": ["POST"]
  },
  "api.web.munio.package": {
    "uri": "api\/web\/munio\/packages\/{package}",
    "methods": ["GET", "HEAD"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.update": {
    "uri": "api\/web\/munio\/packages\/{package}",
    "methods": ["POST"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.archive": {
    "uri": "api\/web\/munio\/packages\/{package}\/archive",
    "methods": ["POST"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.restore": {
    "uri": "api\/web\/munio\/packages\/{package}\/restore",
    "methods": ["POST"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.courses": {
    "uri": "api\/web\/munio\/packages\/{package}\/courses",
    "methods": ["GET", "HEAD"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.courses.add": {
    "uri": "api\/web\/munio\/packages\/{package}\/courses",
    "methods": ["POST"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.courses.remove": {
    "uri": "api\/web\/munio\/packages\/{package}\/courses",
    "methods": ["DELETE"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.courses.update": {
    "uri": "api\/web\/munio\/packages\/{package}\/courses",
    "methods": ["PUT"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.courses-addable": {
    "uri": "api\/web\/munio\/packages\/{package}\/courses-addable",
    "methods": ["GET", "HEAD"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.companies": {
    "uri": "api\/web\/munio\/packages\/{package}\/companies",
    "methods": ["GET", "HEAD"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.companies.update": {
    "uri": "api\/web\/munio\/packages\/{package}\/companies",
    "methods": ["PUT"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.company.add": {
    "uri": "api\/web\/munio\/packages\/{package}\/companies\/{company}",
    "methods": ["POST"],
    "parameters": ["package", "company"],
    "bindings": {
      "package": "id",
      "company": "id"
    }
  },
  "api.web.munio.package.company.remove": {
    "uri": "api\/web\/munio\/packages\/{package}\/companies\/{company}",
    "methods": ["DELETE"],
    "parameters": ["package", "company"],
    "bindings": {
      "package": "id",
      "company": "id"
    }
  },
  "api.web.munio.package.companies-addable": {
    "uri": "api\/web\/munio\/packages\/{package}\/companies-addable",
    "methods": ["GET", "HEAD"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.package.report": {
    "uri": "api\/web\/munio\/packages\/{package}\/report",
    "methods": ["GET", "HEAD"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.users": {
    "uri": "api\/web\/munio\/users",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.merge.users": {
    "uri": "api\/web\/munio\/merge\/users",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.merge.users.show": {
    "uri": "api\/web\/munio\/merge\/users\/{merge}",
    "methods": ["GET", "HEAD"],
    "parameters": ["merge"],
    "bindings": {
      "merge": "id"
    }
  },
  "api.web.munio.merge.users.create": {
    "uri": "api\/web\/munio\/merge\/users",
    "methods": ["POST"]
  },
  "api.web.munio.merge.users.update": {
    "uri": "api\/web\/munio\/merge\/users\/{merge}",
    "methods": ["PATCH"],
    "parameters": ["merge"],
    "bindings": {
      "merge": "id"
    }
  },
  "api.web.munio.merge.users.execute": {
    "uri": "api\/web\/munio\/merge\/users\/{merge}\/execute",
    "methods": ["POST"],
    "parameters": ["merge"],
    "bindings": {
      "merge": "id"
    }
  },
  "api.web.munio.merge.users.delete": {
    "uri": "api\/web\/munio\/merge\/users\/{merge}",
    "methods": ["DELETE"],
    "parameters": ["merge"],
    "bindings": {
      "merge": "id"
    }
  },
  "api.web.munio.merge.users.deleteCandidate": {
    "uri": "api\/web\/munio\/merge\/users\/candidate\/{user}",
    "methods": ["DELETE"],
    "parameters": ["user"],
    "bindings": {
      "user": "id"
    }
  },
  "api.web.munio.certificate.import": {
    "uri": "api\/web\/munio\/certificate\/import\/{type}",
    "methods": ["POST"],
    "parameters": ["type"]
  },
  "api.web.munio.charts.sales": {
    "uri": "api\/web\/munio\/charts\/sales",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.charts.storage": {
    "uri": "api\/web\/munio\/charts\/storage",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.charts.user-countries": {
    "uri": "api\/web\/munio\/charts\/user-countries",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.charts.package-arr": {
    "uri": "api\/web\/munio\/charts\/package-arr",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.charts.package-arr.package": {
    "uri": "api\/web\/munio\/charts\/package-arr\/{package}",
    "methods": ["GET", "HEAD"],
    "parameters": ["package"],
    "bindings": {
      "package": "id"
    }
  },
  "api.web.munio.iprules": {
    "uri": "api\/web\/munio\/iprules",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.iprules.save": {
    "uri": "api\/web\/munio\/iprules",
    "methods": ["POST"]
  },
  "api.web.munio.iprules.delete": {
    "uri": "api\/web\/munio\/iprules\/{rule}",
    "methods": ["DELETE"],
    "parameters": ["rule"],
    "bindings": {
      "rule": "id"
    }
  },
  "api.web.munio.notification": {
    "uri": "api\/web\/munio\/notification",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.notification.save": {
    "uri": "api\/web\/munio\/notification",
    "methods": ["POST"]
  },
  "api.web.munio.notification.delete": {
    "uri": "api\/web\/munio\/notification",
    "methods": ["DELETE"]
  },
  "api.web.munio.scripts.index": {
    "uri": "api\/web\/munio\/scripts",
    "methods": ["GET", "HEAD"]
  },
  "api.web.munio.scripts.store": {
    "uri": "api\/web\/munio\/scripts",
    "methods": ["POST"]
  },
  "api.web.munio.scripts.build": {
    "uri": "api\/web\/munio\/scripts\/build",
    "methods": ["POST"]
  },
  "api.web.munio.scripts.run": {
    "uri": "api\/web\/munio\/scripts\/run\/{run}",
    "methods": ["GET", "HEAD"],
    "parameters": ["run"],
    "bindings": {
      "run": "id"
    }
  },
  "api.web.munio.scripts.delete": {
    "uri": "api\/web\/munio\/scripts\/{script}",
    "methods": ["DELETE"],
    "parameters": ["script"],
    "bindings": {
      "script": "id"
    }
  },
  "api.web.munio.messages": {
    "uri": "api\/web\/munio\/messages",
    "methods": ["GET", "HEAD"]
  },
  "dev.root": {
    "uri": "api\/docs",
    "methods": ["GET", "HEAD"]
  },
  "dev.openapi": {
    "uri": "api\/docs\/openapi.json",
    "methods": ["GET", "HEAD"]
  },
  "xapi": {
    "uri": "xapi",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ]
  },
  "xapi.agents": {
    "uri": "xapi\/agents",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ]
  },
  "xapi.agents.profile": {
    "uri": "xapi\/agents\/profile",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ]
  },
  "xapi.activities": {
    "uri": "xapi\/activities",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ]
  },
  "xapi.activities.profile": {
    "uri": "xapi\/activities\/profile",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ]
  },
  "xapi.activities.state": {
    "uri": "xapi\/activities\/state",
    "methods": ["GET", "HEAD"]
  },
  "xapi.activities.state.post": {
    "uri": "xapi\/activities\/state",
    "methods": ["POST"]
  },
  "xapi.activities.state.put": {
    "uri": "xapi\/activities\/state",
    "methods": ["PUT"]
  },
  "xapi.statements": {
    "uri": "xapi\/statements",
    "methods": ["GET", "HEAD"]
  },
  "xapi.statements.post": {
    "uri": "xapi\/statements",
    "methods": ["POST"]
  },
  "xapi.statements.put": {
    "uri": "xapi\/statements",
    "methods": ["PUT"]
  },
  "xapi.about": {
    "uri": "xapi\/about",
    "methods": ["GET", "HEAD"]
  },
  "lms.account": {
    "uri": "account\/{account}\/{all?}",
    "methods": ["GET", "HEAD"],
    "parameters": ["account", "all"]
  },
  "lms.play": {
    "uri": "play",
    "methods": ["GET", "POST", "HEAD"]
  },
  "lms.play.error": {
    "uri": "play\/error",
    "methods": ["GET", "HEAD"]
  },
  "lms.play.session": {
    "uri": "play\/session\/{session}",
    "methods": ["GET", "HEAD"],
    "parameters": ["session"]
  },
  "lms.play.attempt": {
    "uri": "play\/attempt\/{attempt}",
    "methods": ["GET", "HEAD"],
    "parameters": ["attempt"]
  },
  "lms.play.attempt.node": {
    "uri": "play\/attempt\/{attempt}\/node\/{node}",
    "methods": ["GET", "HEAD"],
    "parameters": ["attempt", "node"]
  },
  "lms.language": {
    "uri": "language",
    "methods": ["POST"]
  },
  "lms.login": {
    "uri": "login",
    "methods": ["GET", "HEAD"]
  },
  "lms.login.recover": {
    "uri": "login\/recover",
    "methods": ["GET", "HEAD"]
  },
  "lms.login.reset": {
    "uri": "login\/reset\/{token}",
    "methods": ["GET", "HEAD"],
    "parameters": ["token"]
  },
  "lms.logout": {
    "uri": "logout",
    "methods": ["GET", "HEAD"]
  },
  "lms.registration": {
    "uri": "registration",
    "methods": ["GET", "HEAD"]
  },
  "lms.registration.invite": {
    "uri": "registration\/{invite}",
    "methods": ["GET", "HEAD"],
    "parameters": ["invite"]
  },
  "lms.invite.accept": {
    "uri": "invite\/accept",
    "methods": ["POST"]
  },
  "lms.invite.user": {
    "uri": "invite\/user\/{invite}\/{all?}",
    "methods": ["GET", "HEAD"],
    "parameters": ["invite", "all"],
    "bindings": {
      "invite": "uuid"
    }
  },
  "lms.access": {
    "uri": "access",
    "methods": ["GET", "HEAD"]
  },
  "lms.access.gate": {
    "uri": "access\/gate\/{gate}",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "lms.access.gate.requisitions": {
    "uri": "access\/gate\/{gate}\/requisitions",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "lms.access.gate.links": {
    "uri": "access\/gate\/{gate}\/links",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "lms.access.gate.cards": {
    "uri": "access\/gate\/{gate}\/cards",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "lms.access.gate.zones": {
    "uri": "access\/gate\/{gate}\/zones",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "lms.access.gate.companies": {
    "uri": "access\/gate\/{gate}\/companies",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "lms.access.gate.settings": {
    "uri": "access\/gate\/{gate}\/settings",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "lms.access.gate.integration": {
    "uri": "access\/gate\/{gate}\/integration",
    "methods": ["GET", "HEAD"],
    "parameters": ["gate"],
    "bindings": {
      "gate": "id"
    }
  },
  "lms.user.course.attempt.resource.storyline.index": {
    "uri": "user\/course\/{course}\/attempt\/{attempt}\/resource\/{resource}\/story.html",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["course", "attempt", "resource"]
  },
  "lms.user.course.attempt.resource.storyline.index.html5": {
    "uri": "user\/course\/{course}\/attempt\/{attempt}\/resource\/{resource}\/story_html5.html",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["course", "attempt", "resource"]
  },
  "lms.user.course.attempt.resource.storyline.frame": {
    "uri": "user\/course\/{course}\/attempt\/{attempt}\/resource\/{resource}\/story_content\/frame.xml",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["course", "attempt", "resource"]
  },
  "lms.user.course.attempt.resource.storyline.frame.html5": {
    "uri": "user\/course\/{course}\/attempt\/{attempt}\/resource\/{resource}\/html5\/data\/js\/frame.js",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["course", "attempt", "resource"]
  },
  "lms.user.course.attempt.resource.file": {
    "uri": "user\/course\/{course}\/attempt\/{attempt}\/resource\/{resource}\/{file?}",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["course", "attempt", "resource", "file"]
  },
  "lms.resource.download": {
    "uri": "resource\/{resource}\/{name}.{extension}",
    "methods": ["GET", "HEAD"],
    "parameters": ["resource", "name", "extension"],
    "bindings": {
      "resource": "id"
    }
  },
  "lms.user": {
    "uri": "user",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.settings.profile": {
    "uri": "user\/settings\/profile",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.settings.account": {
    "uri": "user\/settings\/account",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.settings.profile.update": {
    "uri": "user\/settings\/profile",
    "methods": ["POST"]
  },
  "lms.user.settings.account.update": {
    "uri": "user\/settings\/account",
    "methods": ["POST"]
  },
  "lms.user.settings.confirm": {
    "uri": "user\/settings\/confirm",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.access": {
    "uri": "user\/access",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.access.link": {
    "uri": "user\/access\/link\/{link}",
    "methods": ["GET", "HEAD"],
    "parameters": ["link"],
    "bindings": {
      "link": "slug"
    }
  },
  "lms.user.access.link.register": {
    "uri": "user\/access\/link\/{link}",
    "methods": ["POST"],
    "parameters": ["link"],
    "bindings": {
      "link": "slug"
    }
  },
  "lms.user.access.company": {
    "uri": "user\/access\/company\/{company}",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.user.access.company.requirement": {
    "uri": "user\/access\/company\/{company}\/requirement\/{requirement}",
    "methods": ["GET", "HEAD"],
    "parameters": ["company", "requirement"],
    "bindings": {
      "company": "id",
      "requirement": "id"
    }
  },
  "lms.user.orders": {
    "uri": "user\/orders",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.order": {
    "uri": "user\/orders\/{order}",
    "methods": ["GET", "HEAD"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "lms.user.courses": {
    "uri": "user\/course",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.courses.invite": {
    "uri": "user\/course",
    "methods": ["POST"]
  },
  "lms.user.course": {
    "uri": "user\/course\/{course}",
    "methods": ["GET", "HEAD"],
    "parameters": ["course"]
  },
  "lms.user.course.attempt": {
    "uri": "user\/course\/{course}\/attempt\/{attempt}",
    "methods": ["GET", "HEAD"],
    "parameters": ["course", "attempt"]
  },
  "lms.user.course.attempt.completed": {
    "uri": "user\/course\/{course}\/attempt\/{attempt}\/completed",
    "methods": ["GET", "HEAD"],
    "parameters": ["course", "attempt"]
  },
  "lms.user.inbox": {
    "uri": "user\/inbox",
    "methods": ["GET", "HEAD"]
  },
  "lms.user.inbox.message": {
    "uri": "user\/inbox\/{message}",
    "methods": ["GET", "HEAD"],
    "parameters": ["message"]
  },
  "lms.user.inbox.attachment": {
    "uri": "user\/inbox\/{message}\/{attachment}",
    "methods": ["GET", "HEAD"],
    "parameters": ["message", "attachment"]
  },
  "lms.admin": {
    "uri": "admin",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.companies": {
    "uri": "admin\/companies",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.roles": {
    "uri": "admin\/roles",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.approvals": {
    "uri": "admin\/approvals",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.message.body": {
    "uri": "admin\/messages\/{message}\/body",
    "methods": ["GET", "HEAD"],
    "parameters": ["message"],
    "bindings": {
      "message": "id"
    }
  },
  "lms.admin.orders": {
    "uri": "admin\/orders",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.order": {
    "uri": "admin\/orders\/{order}",
    "methods": ["GET", "HEAD"],
    "parameters": ["order"],
    "bindings": {
      "order": "id"
    }
  },
  "lms.admin.subscriptions": {
    "uri": "admin\/subscriptions",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.courses": {
    "uri": "admin\/courses",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.courses.create": {
    "uri": "admin\/courses\/create",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.course": {
    "uri": "admin\/courses\/{id}",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.participants": {
    "uri": "admin\/courses\/{id}\/enrollment",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.enrollment": {
    "uri": "admin\/courses\/{id}\/enrollment",
    "methods": ["POST"],
    "parameters": ["id"]
  },
  "lms.admin.course.enrollment.toggle": {
    "uri": "admin\/courses\/{id}\/enrollment\/toggle",
    "methods": ["POST"],
    "parameters": ["id"]
  },
  "lms.admin.course.sessions": {
    "uri": "admin\/courses\/{id}\/sessions",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.details": {
    "uri": "admin\/courses\/{id}\/details",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.settings": {
    "uri": "admin\/courses\/{id}\/settings",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.licenses": {
    "uri": "admin\/courses\/{id}\/licenses",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.session_requests": {
    "uri": "admin\/courses\/{id}\/session-requests",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.product": {
    "uri": "admin\/courses\/{id}\/product",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.product.update": {
    "uri": "admin\/courses\/{id}\/product",
    "methods": ["POST"],
    "parameters": ["id"]
  },
  "lms.admin.course.product.create": {
    "uri": "admin\/courses\/{id}\/product\/create",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.product.store": {
    "uri": "admin\/courses\/{id}\/product\/create",
    "methods": ["POST"],
    "parameters": ["id"]
  },
  "lms.admin.course.product.update.translations": {
    "uri": "admin\/courses\/{id}\/product\/translations",
    "methods": ["POST"],
    "parameters": ["id"]
  },
  "lms.admin.course.markets": {
    "uri": "admin\/courses\/{id}\/markets",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.admin.course.market": {
    "uri": "admin\/courses\/{id}\/markets\/{shop}",
    "methods": ["GET", "HEAD"],
    "parameters": ["id", "shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "lms.admin.course.market.submit": {
    "uri": "admin\/courses\/{id}\/markets\/{shop}",
    "methods": ["POST"],
    "parameters": ["id", "shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "lms.admin.course.market.withdraw": {
    "uri": "admin\/courses\/{id}\/markets\/{shop}",
    "methods": ["DELETE"],
    "parameters": ["id", "shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "lms.admin.users": {
    "uri": "admin\/users",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.users.admins": {
    "uri": "admin\/users\/admins",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.users.locks": {
    "uri": "admin\/users\/locks",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.users.locks.remove": {
    "uri": "admin\/users\/locks",
    "methods": ["DELETE"]
  },
  "lms.admin.user": {
    "uri": "admin\/users\/{user}",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"]
  },
  "lms.admin.user.update": {
    "uri": "admin\/users\/{user}",
    "methods": ["POST"],
    "parameters": ["user"]
  },
  "lms.admin.user.password": {
    "uri": "admin\/users\/{user}\/password",
    "methods": ["POST"],
    "parameters": ["user"]
  },
  "lms.admin.user.relationships": {
    "uri": "admin\/users\/{user}\/relationships",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"]
  },
  "lms.admin.user.courses": {
    "uri": "admin\/users\/{user}\/courses",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"]
  },
  "lms.admin.user.roles": {
    "uri": "admin\/users\/{user}\/roles",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"]
  },
  "lms.admin.user.roles.update": {
    "uri": "admin\/users\/{user}\/roles",
    "methods": ["POST"],
    "parameters": ["user"]
  },
  "lms.admin.user.permissions": {
    "uri": "admin\/users\/{user}\/permissions",
    "methods": ["GET", "HEAD"],
    "parameters": ["user"]
  },
  "lms.admin.user.permissions.update": {
    "uri": "admin\/users\/{user}\/permissions",
    "methods": ["POST"],
    "parameters": ["user"]
  },
  "lms.admin.enrollment": {
    "uri": "admin\/enrollment",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.enrollment.users": {
    "uri": "admin\/enrollment\/users",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.enrollment.create": {
    "uri": "admin\/enrollment\/create",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.enrollment.courses": {
    "uri": "admin\/enrollment\/courses",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.enrollment.code": {
    "uri": "admin\/enrollment\/code",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.enrollment.recipients": {
    "uri": "admin\/enrollment\/invite\/{invite}",
    "methods": ["GET", "HEAD"],
    "parameters": ["invite"]
  },
  "lms.admin.enrollment.recipients.add": {
    "uri": "admin\/enrollment\/invite\/{invite}",
    "methods": ["POST"],
    "parameters": ["invite"]
  },
  "lms.admin.enrollment.settings": {
    "uri": "admin\/enrollment\/invite\/{invite}\/settings",
    "methods": ["GET", "HEAD"],
    "parameters": ["invite"]
  },
  "lms.admin.enrollment.settings.update": {
    "uri": "admin\/enrollment\/invite\/{invite}\/settings",
    "methods": ["POST"],
    "parameters": ["invite"]
  },
  "lms.admin.enrollment.delete": {
    "uri": "admin\/enrollment\/invite\/{invite}\/delete",
    "methods": ["POST"],
    "parameters": ["invite"]
  },
  "lms.admin.enrollment.archive": {
    "uri": "admin\/enrollment\/invite\/{invite}\/archive",
    "methods": ["POST"],
    "parameters": ["invite"]
  },
  "lms.admin.enrollment.restore": {
    "uri": "admin\/enrollment\/invite\/{invite}\/restore",
    "methods": ["POST"],
    "parameters": ["invite"]
  },
  "lms.admin.reports": {
    "uri": "admin\/reports",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.reports.licenses": {
    "uri": "admin\/reports\/licenses",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.reports.completions": {
    "uri": "admin\/reports\/completions",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.reports.diplomas": {
    "uri": "admin\/reports\/diplomas",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.reports.status": {
    "uri": "admin\/reports\/status",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.reports.course-revenue": {
    "uri": "admin\/reports\/course-revenue",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.reports.reminders": {
    "uri": "admin\/reports\/reminders",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.reports.reminders.activity": {
    "uri": "admin\/reports\/reminders\/activity",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.reports.reminders.message": {
    "uri": "admin\/reports\/reminders\/message\/{message}",
    "methods": ["GET", "HEAD"],
    "parameters": ["message"]
  },
  "lms.admin.account": {
    "uri": "admin\/account",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.account.update.info": {
    "uri": "admin\/account",
    "methods": ["POST"]
  },
  "lms.admin.account.departments": {
    "uri": "admin\/account\/departments",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.account.locations": {
    "uri": "admin\/account\/locations",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.account.api": {
    "uri": "admin\/account\/api",
    "methods": ["GET", "HEAD"]
  },
  "lms.admin.account.api.client": {
    "uri": "admin\/account\/api\/{client}",
    "methods": ["GET", "HEAD"],
    "parameters": ["client"]
  },
  "lms.admin.resource.upload": {
    "uri": "admin\/resources\/{object}\/{resource}\/{token}",
    "methods": ["POST"],
    "parameters": ["object", "resource", "token"],
    "bindings": {
      "object": "id",
      "resource": "ulid"
    }
  },
  "lms.munio": {
    "uri": "system",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.audits": {
    "uri": "system\/audits",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.users": {
    "uri": "system\/users",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.users.merge": {
    "uri": "system\/users\/merge",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.companies": {
    "uri": "system\/companies",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.company.details": {
    "uri": "system\/companies\/{company}",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.munio.company.users": {
    "uri": "system\/companies\/{company}\/users",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.munio.company.courses": {
    "uri": "system\/companies\/{company}\/courses",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.munio.company.departments": {
    "uri": "system\/companies\/{company}\/departments",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.munio.company.account": {
    "uri": "system\/companies\/{company}\/account",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.munio.company.access": {
    "uri": "system\/companies\/{company}\/access",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.munio.company.ecoid": {
    "uri": "system\/companies\/{company}\/ecoid",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.munio.company.audit": {
    "uri": "system\/companies\/{company}\/audit",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"],
    "bindings": {
      "company": "id"
    }
  },
  "lms.munio.courses": {
    "uri": "system\/courses",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.course": {
    "uri": "system\/courses\/editor\/{course}",
    "methods": ["GET", "HEAD"],
    "parameters": ["course"],
    "bindings": {
      "course": "id"
    }
  },
  "lms.munio.courses.packages": {
    "uri": "system\/courses\/packages",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.reports.quarterly-revenue": {
    "uri": "system\/quarterly-revenue",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.reports.quarterly-revenue.report": {
    "uri": "system\/quarterly-revenue\/report",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.reports.quarterly-revenue.export": {
    "uri": "system\/quarterly-revenue\/export",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.integrations": {
    "uri": "system\/integrations",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.integration": {
    "uri": "system\/integrations\/{integration}",
    "methods": ["GET", "HEAD"],
    "parameters": ["integration"],
    "bindings": {
      "integration": "id"
    }
  },
  "lms.munio.certificates": {
    "uri": "system\/certificates",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.competencies": {
    "uri": "system\/competencies",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.messages": {
    "uri": "system\/messages",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.components": {
    "uri": "system\/components",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.iprules": {
    "uri": "system\/iprules",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.notification": {
    "uri": "system\/notification",
    "methods": ["GET", "HEAD"]
  },
  "lms.munio.scripts": {
    "uri": "system\/scripts",
    "methods": ["GET", "HEAD"]
  },
  "lms.index": {
    "uri": "{language}",
    "methods": ["GET", "HEAD"],
    "parameters": ["language"]
  },
  "lms.shop.redirect": {
    "uri": "{language}\/shop",
    "methods": ["GET", "HEAD"],
    "parameters": ["language"]
  },
  "lms.shop.redirect.old": {
    "uri": "{language}\/shop\/{oldshopsections}\/{all?}",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["language", "oldshopsections", "all"]
  },
  "lms.shop": {
    "uri": "{language}\/shop\/{shop}",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "lms.shop.cart": {
    "uri": "{language}\/shop\/{shop}\/cart",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.terms": {
    "uri": "{language}\/shop\/{shop}\/terms",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.product": {
    "uri": "{language}\/shop\/{shop}\/product\/{product}",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "product"],
    "bindings": {
      "shop": "slug"
    }
  },
  "lms.shop.product.modal": {
    "uri": "{language}\/shop\/{shop}\/product\/{product}\/modal",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "product"]
  },
  "lms.shop.product.demo": {
    "uri": "{language}\/shop\/{shop}\/product\/{product}\/demo",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "product"]
  },
  "lms.shop.product.session_request.unsubscribe": {
    "uri": "{language}\/shop\/{shop}\/product\/{product}\/session-request\/{session_request}\/unsubscribe",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "product", "session_request"]
  },
  "lms.shop.checkout": {
    "uri": "{language}\/shop\/{shop}\/checkout",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.checkout.complete": {
    "uri": "{language}\/shop\/{shop}\/checkout\/complete",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.checkout.exit": {
    "uri": "{language}\/shop\/{shop}\/checkout\/complete",
    "methods": ["POST"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.checkout.resume": {
    "uri": "{language}\/shop\/{shop}\/checkout\/resume\/{cart}",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "cart"],
    "bindings": {
      "cart": "uuid"
    }
  },
  "lms.shop.admin.members": {
    "uri": "{language}\/shop\/{shop}\/admin\/members",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.members.add": {
    "uri": "{language}\/shop\/{shop}\/admin\/members\/add",
    "methods": ["POST"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.members.remove": {
    "uri": "{language}\/shop\/{shop}\/admin\/members\/remove",
    "methods": ["POST"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.suppliers": {
    "uri": "{language}\/shop\/{shop}\/admin\/suppliers",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.suppliers.add": {
    "uri": "{language}\/shop\/{shop}\/admin\/suppliers\/add",
    "methods": ["POST"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.suppliers.remove": {
    "uri": "{language}\/shop\/{shop}\/admin\/suppliers\/remove",
    "methods": ["POST"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.orders": {
    "uri": "{language}\/shop\/{shop}\/admin\/orders",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.order": {
    "uri": "{language}\/shop\/{shop}\/admin\/orders\/{order}",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "order"],
    "bindings": {
      "order": "id"
    }
  },
  "lms.shop.admin.order.invoice": {
    "uri": "{language}\/shop\/{shop}\/admin\/orders\/{order}\/invoices\/{invoice}",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "order", "invoice"]
  },
  "lms.shop.admin.products": {
    "uri": "{language}\/shop\/{shop}\/admin\/products",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.subscriptions": {
    "uri": "{language}\/shop\/{shop}\/admin\/subscriptions",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.categories": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.categories.form": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories\/create",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.categories.create": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories\/create",
    "methods": ["POST"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.category": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories\/{category}",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "category"]
  },
  "lms.shop.admin.category.update": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories\/{category}",
    "methods": ["POST"],
    "parameters": ["language", "shop", "category"]
  },
  "lms.shop.admin.category.delete": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories\/{category}",
    "methods": ["DELETE"],
    "parameters": ["language", "shop", "category"]
  },
  "lms.shop.admin.category.products": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories\/{category}\/products",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop", "category"]
  },
  "lms.shop.admin.category.products.update": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories\/{category}\/products",
    "methods": ["POST"],
    "parameters": ["language", "shop", "category"]
  },
  "lms.shop.admin.category.reorder": {
    "uri": "{language}\/shop\/{shop}\/admin\/categories\/{category}\/reorder",
    "methods": ["POST"],
    "parameters": ["language", "shop", "category"]
  },
  "lms.shop.admin.settings": {
    "uri": "{language}\/shop\/{shop}\/admin\/settings",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "shop"]
  },
  "lms.shop.admin.settings.update": {
    "uri": "{language}\/shop\/{shop}\/admin\/settings\/update",
    "methods": ["POST"],
    "parameters": ["language", "shop"],
    "bindings": {
      "shop": "slug"
    }
  },
  "lms.shop.admin.settings.update.message": {
    "uri": "{language}\/shop\/{shop}\/admin\/settings\/message",
    "methods": ["POST"],
    "parameters": ["language", "shop"]
  },
  "lms.course.free": {
    "uri": "{language}\/course\/free\/{name}",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "name"]
  },
  "lms.pdf.diploma": {
    "uri": "{language}\/pdf\/diploma\/{id}.pdf",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "id"]
  },
  "lms.pdf.salesorder.confirmation": {
    "uri": "{language}\/pdf\/salesorder\/confirmation\/{id}.pdf",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "id"]
  },
  "lms.pdf.salesorder.invoice": {
    "uri": "{language}\/pdf\/salesorder\/invoice\/{invoice}.pdf",
    "methods": ["GET", "HEAD"],
    "parameters": ["language", "invoice"],
    "bindings": {
      "invoice": "id"
    }
  },
  "lms.error": {
    "uri": "error\/{code}",
    "methods": ["GET", "HEAD"],
    "parameters": ["code"]
  },
  "lms.email.preview": {
    "uri": "email\/{type}",
    "methods": ["GET", "HEAD"],
    "parameters": ["type"]
  },
  "lms.context": {
    "uri": "context",
    "methods": ["POST"]
  },
  "lms.context.company": {
    "uri": "context\/{company}",
    "methods": ["GET", "HEAD"],
    "parameters": ["company"]
  },
  "lms.pdf.diploma.redirect": {
    "uri": "pdf\/diploma\/{id}.pdf",
    "methods": ["GET", "HEAD"],
    "parameters": ["id"]
  },
  "lms.document": {
    "uri": "document\/{document}-{slug}\/{mode?}",
    "methods": ["GET", "HEAD"],
    "parameters": ["document", "slug", "mode"]
  },
  "keepalive": {
    "uri": "keepalive",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ]
  },
  "lms.tutorial": {
    "uri": "tutorial\/{identifier}",
    "methods": ["GET", "HEAD"],
    "parameters": ["identifier"]
  },
  "lms.shop.product.demostory": {
    "uri": "demo\/{product}\/story.html",
    "methods": ["GET", "HEAD"],
    "parameters": ["product"],
    "bindings": {
      "product": "id"
    }
  },
  "dynimage.display": {
    "uri": "{cbhash}\/img\/{group}\/{size}\/{id}.{extension}",
    "methods": ["GET", "HEAD"],
    "parameters": ["cbhash", "group", "size", "id", "extension"]
  },
  "dynimage.source": {
    "uri": "{cbhash}\/img\/{group}\/{id}.{extension}",
    "methods": ["GET", "HEAD"],
    "parameters": ["cbhash", "group", "id", "extension"]
  },
  "dynimage.update": {
    "uri": "img\/{group}\/{id}.{extension}",
    "methods": ["POST"],
    "parameters": ["group", "id", "extension"]
  },
  "dynimage.remove": {
    "uri": "img\/{group}\/{id}.{extension}",
    "methods": ["DELETE"],
    "parameters": ["group", "id", "extension"]
  },
  "root.invite": {
    "uri": "r\/{invite}",
    "methods": ["GET", "HEAD"],
    "parameters": ["invite"]
  },
  "munioaccess.link": {
    "uri": "l\/{link}",
    "methods": ["GET", "HEAD"],
    "parameters": ["link"],
    "bindings": {
      "link": "slug"
    }
  },
  "terms": {
    "uri": "terms",
    "methods": ["GET", "HEAD"]
  },
  "void": {
    "uri": "void\/{all?}",
    "methods": [
      "GET",
      "HEAD",
      "POST",
      "PUT",
      "PATCH",
      "DELETE",
      "OPTIONS",
      "QUERY"
    ],
    "parameters": ["all"]
  },
  "health": {
    "uri": "health",
    "methods": ["GET", "HEAD"]
  },
  "root": {
    "uri": "\/",
    "methods": ["GET", "HEAD"]
  },
  "fallback": {
    "uri": "{fallbackPlaceholder}",
    "methods": ["GET", "HEAD"],
    "parameters": ["fallbackPlaceholder"]
  }
}
